import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API_BASE } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { DoorOpen, Clock, RefreshCw } from "lucide-react";

export default function WallDisplay() {
  const { publicId } = useParams();
  const [data, setData] = useState(null);
  const [time, setTime] = useState(new Date());

  const load = useCallback(() => {
    axios.get(`${API_BASE}/public/wall/${publicId}`).then((r) => setData(r.data)).catch(() => {});
  }, [publicId]);

  useEffect(() => {
    load();
    const t1 = setInterval(load, 15000);
    const t2 = setInterval(() => setTime(new Date()), 1000);
    return () => { clearInterval(t1); clearInterval(t2); };
  }, [load]);

  const tone = { AVAILABLE: "#10B981", BOOKED: "#EF4444", STARTING_SOON: "#F59E0B" };

  return (
    <div className="min-h-screen sf-grid-bg text-white p-6 sm:p-10">
      <div className="flex items-center justify-between">
        <Logo className="h-8" light />
        <div className="text-right">
          <p className="font-display text-4xl font-bold tabular-nums">{time.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</p>
          <p className="text-blue-200/70 text-sm">{data?.branch} · {time.toLocaleDateString()}</p>
        </div>
      </div>

      <h1 className="font-display text-2xl font-bold mt-8 flex items-center gap-2">Meeting Rooms <RefreshCw size={16} className="text-blue-300 animate-spin" style={{ animationDuration: "3s" }} /></h1>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-6">
        {(data?.rooms || []).map((r) => (
          <div key={r.room_name} className="rounded-2xl p-6 border border-white/10 bg-white/5 backdrop-blur" data-testid={`wall-room-${r.room_name.replace(/\s/g, "-")}`}>
            <div className="flex items-center justify-between">
              <h2 className="font-display text-2xl font-bold">{r.room_name}</h2>
              <DoorOpen size={22} className="text-blue-200/50" />
            </div>
            <div className="mt-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-bold" style={{ background: `${tone[r.status]}22`, color: tone[r.status] }}>
              <span className="w-2 h-2 rounded-full" style={{ background: tone[r.status] }} />
              {r.status.replace(/_/g, " ")}
            </div>
            <div className="mt-4 space-y-1 text-sm">
              {r.current && <p className="text-white/90"><Clock size={13} className="inline mr-1" /> Now: {r.current.start} – {r.current.end}</p>}
              {r.next && <p className="text-blue-200/70">Next: {r.next.start} – {r.next.end}</p>}
              {!r.current && !r.next && <p className="text-blue-200/50">No bookings scheduled</p>}
            </div>
          </div>
        ))}
        {data && data.rooms.length === 0 && <p className="text-blue-200/60">No active meeting rooms at this branch.</p>}
      </div>
    </div>
  );
}
